module.exports = "/assets/1cfe4be50be24c53288852b4e75a3a75.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/v2-icons/plane.svg
// module id = 3323
// module chunks = 0